"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Play, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function PerformanceHero() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: trustRef,
    isVisible: trustVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const trustItems = [{
    label: "Lab Tested"
  }, {
    label: "COA Verified"
  }, {
    label: "Cold Stored"
  }];
  const avatars = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719279/img/athlete_profile_1.webp",
    fallback: "IH"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719279/img/athlete_profile_2.png",
    fallback: "IH"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719279/img/athlete_profile_3.png",
    fallback: "IH"
  }];
  return <section data-section-id="877" id="elite-performance-hero" className="bg-background text-foreground relative min-h-[90vh] lg:min-h-screen w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "radial-gradient(circle, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} />

      {}
      <div className="pointer-events-none absolute -top-32 -right-32 h-[500px] w-[500px] rounded-lg opacity-60" style={{
      background: "radial-gradient(circle, var(--primary) 0%, transparent 70%)",
      filter: "blur(120px)"
    }} />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-[500px] w-[500px] rounded-lg opacity-40" style={{
      background: "radial-gradient(circle, var(--chart-2) 0%, transparent 70%)",
      filter: "blur(120px)"
    }} />

      {}
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 pt-24 pb-32 lg:pt-32 lg:pb-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {}
          <div className="lg:col-span-7 flex flex-col">
            {}
            <div ref={eyebrowRef} data-index={0} className={`flex items-center gap-3 transition-all duration-700 ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <span className="font-mono text-[12px] uppercase tracking-widest !text-[rgba(251,189,35,1)]">ironhabitpeptides.com</span>
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75 !bg-[rgba(251,189,35,1)]" />
                
              </span>
            </div>

            {}
            <div ref={headlineRef} className={`mt-6 flex flex-col items-start transition-all duration-700 delay-100 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <WvcLogo className="h-32 md:h-40 w-auto" />
              <h1 className="font-default mt-4 text-[32px] sm:text-[48px] lg:text-[56px] leading-none tracking-[0.2em] font-bold uppercase text-foreground">IRON HABIT PEptides</h1>
            </div>

            {}
            <p ref={subRef} className={`font-sans mt-8 text-[18px] leading-relaxed text-muted-foreground max-w-[480px] transition-all duration-700 delay-200 ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>Iron Habit Peptides delivers laboratory-grade compounds for advanced research purposes. Uncompromising purity, rigorous testing, and absolute consistency for the dedicated.</p>

            {}
            <div ref={ctaRef} className={`mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-all duration-700 delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild size="lg" className="font-medium inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 group h-12 px-7 rounded-lg text-primary-foreground text-base !font-bold !bg-[rgba(251,189,35,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">
                <Link to="/ShopPage">Shop Now</Link>
              </Button>

              <Button asChild size="lg" variant="ghost" className="group h-12 px-6 rounded-lg text-foreground hover:bg-foreground/5 font-medium text-base">
                
              </Button>
            </div>

            {}
            <div ref={trustRef} className={`mt-8 flex flex-wrap items-center gap-x-4 gap-y-2 transition-all duration-700 delay-400 ${trustVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              {trustItems.map((item, i) => <div data-index={i} key={i} className="flex items-center gap-4">
                  <span className="font-mono text-[13px] text-muted-foreground">
                    {item.label}
                  </span>
                  {i < trustItems.length - 1 && <span className="font-mono text-muted-foreground/50">&middot;</span>}
                </div>)}
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 delay-200 ${imageVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-6 scale-95"}`}>
            <div className="relative rounded-lg overflow-hidden border border-primary/30">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719279/img/peptide_vial_showcase.webp" alt="Premium peptide vial in laboratory setting" loading="lazy" decoding="async" className="w-full h-[480px] sm:h-[560px] lg:h-[640px] object-cover" style={{
              filter: "saturate(0.9) contrast(1.05)"
            }} src="https://divine-husky-1.10web.cloud/wp-content/uploads/2026/06/AEDE8ECA-DA15-42FF-9464-E9466DA64EF6.png" src="https://ironhabitpeptides.com/wp-content/uploads/2026/07/72FFACA4-14EA-474A-8BC5-AD4625305F0E.png" />

              {}
              <WvcLogo className="h-12 w-auto absolute top-4 left-4 z-20" />
              <div className="absolute top-20 left-4 text-[10px] sm:text-[12px] uppercase font-mono tracking-tighter text-white/80 z-20 leading-tight"><br /></div>

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none" />
            </div>

            {}
            

            {}
            <div className="absolute top-6 right-6 backdrop-blur-md bg-background/40 border border-border rounded-lg px-2.5 py-1.5 shadow-lg">
              <div className="flex items-center gap-3">
                <div className="flex flex-col">
                  <span className="font-default text-base font-semibold text-foreground leading-none">
                    5.0
                  </span>
                  <div className="flex items-center gap-0.5 mt-1">
                    {[0, 1, 2, 3, 4].map(i => <Star data-index={i} key={i} className="size-2 fill-primary text-primary" />)}
                  </div>
                </div>
                <div className="flex -space-x-2">
                  {avatars.map((avatar, i) => <SafeHydrate><Avatar data-index={i} key={i} className="size-5 border-2 border-background">
                      <AvatarImage src={avatar.src} alt="Verified Researcher" />
                      <AvatarFallback className="text-[8px] bg-muted text-muted-foreground">
                        {avatar.fallback}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-3">
          <span className="font-mono uppercase tracking-widest text-muted-foreground !text-xl">
            SCROLL
          </span>
          <div className="relative h-12 w-px bg-muted-foreground/30 overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 !bg-[rgba(251,189,35,1)]" style={{
            animation: "scrollLine 2s ease-in-out infinite"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}